<template>
  <ig-page-base
    :loading="loading"
    :is-boxed="true"
    :title="$t('pageForgotPassword.title')"
    class="page-forgot-password">
    <ig-form-schema
      v-if="!sent"
      :schema="customSchema"
      @submit="onFormSubmit">
      <template slot="actions">
        <div class="buttons page-forgot-password__buttons">
          <router-link
            :to="{ name: 'page-login' }"
            class="button is-text has-text-weight-bold">
            {{ $t('pageForgotPassword.form.cancel') }}
          </router-link>

          <b-button
            class="is-uppercase"
            type="is-primary"
            native-type="submit">
            {{ $t('pageForgotPassword.form.submit') }}
          </b-button>
        </div>
      </template>
    </ig-form-schema>

    <template v-else>
      <b-message type="is-info">
        <p class="field" v-html="$t('pageForgotPassword.successMessage')" />
      </b-message>

      <div class="buttons page-forgot-password__buttons">
        <router-link
          :to="{ name: 'page-login' }"
          class="button is-text has-text-weight-bold">
          {{ $t('pageForgotPassword.backButton') }}
        </router-link>
      </div>
    </template>

  </ig-page-base>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import { IgPageBase, IgFormSchema } from '@integrai/ui';

const { mapState, mapActions } = createNamespacedHelpers('forgotPassword');

export default Vue.extend({
  name: 'page-forgot-password',
  components: {
    IgPageBase,
    IgFormSchema,
  },
  data() {
    return {
      sent: false,
      form: {
        email: null,
      },
    };
  },
  computed: {
    ...mapState([
      'loading',
    ]),
    customSchema() {
      return {
        fields: [
          {
            name: 'email',
            component: 'input',
            fieldAttrs: {
              label: this.$t('pageForgotPassword.form.email.label'),
            },
            attrs: {
              placeholder: this.$t('pageForgotPassword.form.email.placeholder'),
              'icon-pack': 'fas',
              icon: 'envelope',
            },
            validation: {
              name: this.$t('pageForgotPassword.form.email.label'),
              rules: 'required|email',
            },
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions([
      'forgotPassword',
    ]),
    onFormSubmit(form) {
      this.form = form;

      return this.forgotPassword(form).then(() => {
        this.sent = true;
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.page-forgot-password {
  width: 100%;

  &__buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1.5rem;
  }
}
</style>
